import { CompanyTypeView, ContactView, MarketView, UserView } from '@api-proxies';
import {
    IAdditionalFiltersConfig,
    IGenericAdditionalFilters
} from '@shared/additional-filters/additional-filters.config';

export const COMPANIES_FILTER_KEY = 'companies';

export interface IAdditionalFiltersCompanies extends IGenericAdditionalFilters {
    contact?: ContactView[];
    market?: MarketView[];
    companyType?: CompanyTypeView[];
    salespersons?: UserView[];
    includeArchived?: boolean;
}

export const COMPANIES_FILTER_CONFIG: IAdditionalFiltersConfig<IAdditionalFiltersCompanies> = {
    entityType: 'companies',

    visibility: {
        companyMainContact: true,
        market: true,
        companyType: true,
        salesperson: true,
        includeArchived: true
    },

    transformToFilters: (formValue: any): IAdditionalFiltersCompanies => {
        return {
            contact: formValue.contact && formValue.contact.length > 0 ? formValue.contact[0] : undefined,
            market: formValue.market && formValue.market.length > 0 ? formValue.market[0] : undefined,
            companyType:
                formValue.companyType && formValue.companyType.length > 0 ? formValue.companyType[0] : undefined,
            salespersons:
                formValue.salespersons && formValue.salespersons.length > 0 ? formValue.salespersons : undefined,
            includeArchived: formValue.includeArchived || undefined
        };
    },

    transformFromFilters: (filters: IAdditionalFiltersCompanies): any => {
        return {
            contact: filters?.contact ? [filters.contact] : [],
            market: filters?.market ? [filters.market] : [],
            companyType: filters?.companyType ? [filters.companyType] : [],
            salespersons: filters?.salespersons || [],
            includeArchived: filters?.includeArchived || undefined
        };
    },

    hasFiltersApplied: (filters: IAdditionalFiltersCompanies | null): boolean => {
        if (!filters) return false;
        const props = ['market', 'contact', 'salespersons', 'companyType'];
        if (props.some((prop) => filters[prop])) return true;
        return filters.includeArchived === true;
    }
};
